import React from 'react'; 
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal, toggleLoading} from "../../../state/ModalSlice/ModalSlice.ts";
import {SECRETS_ENV} from "../../../Config/firebase.ts";
import {useBackend} from "../../../hooks/backend/useBackend.ts";
import {toast} from "react-toastify";
import {CircularProgress, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { increment, Timestamp } from 'firebase/firestore';


export default function RemindPaymentWhatsappModal() {

    const Dispatch = useAppDispatch();
    const open = useAppSelector((state: RootState) => state.ModalSlice.RemindPaymentWhatsappModalOpen);
    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading);
    
    function handleClose() {
        Dispatch(closeModal("RemindPaymentWhatsappModalOpen"))
    }


    // OnSubmit Operations
    const {axiosGetRequest} =useBackend("")
   
    const queryParams = useAppSelector((state: RootState) => state.ArbitrarySlice.ForRemindPaymentWhatsappModal)
 
    const {update:updateOrder} = useBackend(`/ServiceProviders/${queryParams.serviceProviderID}/Orders`);
    async function handleAPICall() {
        console.log('Query params in WhatsApp modal:', queryParams);

        Dispatch(toggleLoading(true))

        const Params = {
            consumerName: queryParams.consumerName,
            chargeable: queryParams.chargeable,
            subscriptionName: queryParams.subscriptionName,
            cycleName: queryParams.bQuickCollect ? queryParams.quickCollectString : (queryParams.invoiceString || queryParams.cycleName),
            studentName: queryParams.studentName,
            payment_link: queryParams.payment_link,
            providerName: queryParams.providerName,
            consumerPhone: queryParams.consumerPhone,
            serviceProviderID:queryParams.serviceProviderID,
            secondaryMobile: queryParams.secondaryMobile,
            email: queryParams.email,
            secondaryEmail: queryParams.secondaryEmail,
            orderId: queryParams.orderId
        }

        try {
            const response: any = await axiosGetRequest(`${SECRETS_ENV.API_END_POINT}/api/paymentReminder`, Params)
            // Update reminder count in order document
            
            await updateOrder(queryParams.orderId, {
                lastReminderTime: Timestamp.fromDate(new Date()),
                reminderCount: increment(1)
            });
            if (response === "error") {

                Dispatch(toggleLoading(false))
                return "error"
            }

        } catch (error) {
       
            Dispatch(toggleLoading(false))
            return "error"
        }
        Dispatch(toggleLoading(false))
        return "success"

    }

    async function onSubmit(e: any) {
        e.preventDefault()
        Dispatch(toggleLoading(true))
        const response = await handleAPICall()
        if (response === "error") {
            toast.error("Error Reminding")
        }else{
            toast.success("Reminder sent successfully in Whatsapp")
        }
        Dispatch(toggleLoading(false))
        Dispatch(closeModal("RemindPaymentWhatsappModalOpen"))
    }

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '16px',
                },
            }}
            maxWidth="md"
            open={open}

            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{paddingY: "50px", paddingX: "60px"}} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Remind for due Payment?</p>
                    {/*<p className={"text-cf_small font-[400] "}>Add New Subscribers to {subscriptionName}</p>*/}
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon/>
                </IconButton></div>

                <div className={"pt-0"}>

                    <p>Click on Yes will send Whatsapp payment reminder with link as applicable!</p>


                </div>

                <div className={"flex gap-2 pt-8"}>

                <button onClick={(e) => {
                        e.preventDefault();
                        handleClose()
                    }} disabled={isLoading}
                            className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>No
                    </button>
                    <button
                        onClick={onSubmit} disabled={isLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>{isLoading &&
                            <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isLoading ? "Loading" : "Yes"}</p>
                    </button>
                
                </div>
            </DialogContent>

        </Dialog>

    </React.Fragment>);
}
